import React,{useState} from 'react'
import { BsEmojiNeutral } from 'react-icons/bs'
export default function ErrorPage(){
    return(
        <div className='mt-2 m-auto'>
        <h2 className='text-lg structure__main__subttl'>404<br/>Page is missing..</h2>
        <div className='flex'>
        <div>Sorry, I could not find the page </div>
        <div className='ml-1 m-auto'><BsEmojiNeutral className='text-lg'/></div>
        </div>     
        <br/><br/>
        </div>
     )
}